export default __webpack_public_path__ + "8232297ab5d7fc37a20b3034565ea28a.svg";